import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faInstagram, faGithub} from '@fortawesome/free-brands-svg-icons';

import {DisplayTimeZone, DisplayLanguage} from 'Components/Settings';

import {translation} from 'Services/TranslationHelpers';
import { asset } from "../../../Services/BaseHelpers";

/**
 * @function Footer
 * @return {JSX.Element}
 * @constructor
 */
const Footer = () => {
    return (
        <footer className="bg-white">
            <div
                className="mx-auto p-6 flex flex-row justify-between">
                <div className="mt-0 order-1">
                    <img className={"mx-auto my-auto w-64"} src={ asset ( 'images/bmw_group.png' ) } />
                </div>
                
                <div className="flex justify-center space-x-6 order-2">
                    <img className={"mx-auto my-auto"} src={ asset ( 'images/bmw.png' ) } />
                    <img className={"mx-auto my-auto"} src={ asset ( 'images/mini.png' ) } />
                </div>
            </div>
        </footer>
    );
};

export default Footer;
